import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import h5Share from '@/utils/h5Share'
import styled from "styled-components";
import rotate from './awardRotate';
import ModalView from '@/components/modal-view'
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import ShareModal from './components/share';
import styles from '@/styles'
import { getObjectFormSerach, jumpTo, userBehaver } from '@/utils'

import { Toast } from "antd-mobile";

import ActiveBG from './imgs/bg@2x.png'
import WheelBG from './imgs/wheel-bg@2x.png'
import WheelPointer from './imgs/wheel-pointer@2x.png'
import WheelPointerDark from './imgs/wheel-pointer-dark@2x.png'
import WheelLight from './imgs/wheel-light@2x.png'
import StandBG from './imgs/stand@2x.png'
import RewardBG from './imgs/reward-bg@2x.png'
import CloseBtn from './imgs/close@2x.png'
import DescTitle from './imgs/desc-title@2x.png'
import Award1 from './imgs/award1@2x.png'
import Award2 from './imgs/award2@2x.png'
import Award3 from './imgs/award3@2x.png'
import Award4 from './imgs/award4@2x.png'
import Award5 from './imgs/award5@2x.png'
import DrawTomorrow from './imgs/again@2x.png';
import EmptyCard from './imgs/overTime@2x.png'
import Delivery from './components/delivery';
import LeadBtn from './imgs/lead@2x.png';
import DeliveryBtn from './imgs/delivery@2x.png';

import bridge from '@/config/JSbridge'

import { getDrawResult, activityInfo, getDrawInfo, getAddrInfo } from './api';
import { connect } from 'react-redux';
import moment from 'moment'

export const isStorm = bwmodel.app === 'storm';

const active_id = 120;

const awardAngleMap = new Map([
  ['市值风云专属水杯', 0],
  ['20积分', 60],
  ['市值风云专属帆布袋', 120],
  ['VIP 1天', 180],
  ['VIP7天', 240],
  ['《价值投资全景图》电子版', 300]
])

let isAnimating = false

const CarnivalGame = ({token}) => {
  const raffleRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [addrInfo, setAddrInfo] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [showEmptyModal, setShowEmptyModal] = useState(false);

  const [activeVisible, setActiveVisible] = useState(true)
  const [raffleCount, setRaffleCount] = useState(0)
  const [awardLsit, setAwardList] = useState([])
  const [drawAwardData, setDrawAwardData] = useState({});

  const shareRef = useRef()
  const lightRef = useRef()
  const descContainer = useRef()
  const bodyContainer = useRef()

  const deliveryRef = useRef();

  const { userName } = getObjectFormSerach(window.location.search);

  const initPage = () => {
    getDrawInfo({activityId: 120}).then(res => {
      const { availableCount, totalAwardList, user } = res;
      setRaffleCount(availableCount);
      setUserInfo(user);

      if (isOverActivityTime(user)) {
        setShowEmptyModal(true);
      }

      const list = totalAwardList || [];
      const award1 = [], award2 = [], award3 = [], award4 =[];
      list.forEach(item => {
        if (item.awardType === 3) {
          award1.push(item)
        }
        if (item.awardType === 1) {
          award2.push(item)
        }
        if (item.awardType === 0) {
          award3.push(item)
        }
        if (item.awardType === 11) {
          award4.push(item)
        }
      })
      setAwardList([...award1, ...award2, ...award3, ...award4]);
    });
  }

  const isOverActivityTime = (user) => {
    if (!isStorm) {
      return false;
    }
    if (!token) {
      return false;
    }
    const info = user || userInfo
    if (!info || !info.createTime) {
      return true;
    }
    const createTime = info.createTime;
    const startTime = moment(createTime).format('YYYY-MM-DD');
    const endTime = moment(startTime).add(7, 'day');
    const now = new Date().valueOf();
    if (now > endTime) {
      return true;
    }
    return false;
  }

  const canDrawTomorrow = (user) => {
    const info = user || userInfo
    if (!info || !info.createTime) {
      return false;
    }
    const createTime = info.createTime;
    const startTime = moment(createTime).format('YYYY-MM-DD');
    const lastDay = moment(startTime).add(6, 'day');
    const now = new Date().valueOf();
    if (now < lastDay) {
      return true;
    }
    return false;
  }

  const getActivityTime = () => {
    if (isOverActivityTime()) {
      return '活动已结束'
    }
    let userInfoCopy = userInfo;
    if (!isStorm || !token) {
      userInfoCopy = { createTime: new Date().valueOf() }
    }
    if (!userInfoCopy || !userInfoCopy.createTime) {
      return '';
    }
    const createTime = userInfoCopy.createTime;
    const endTime = moment(createTime).add(6, 'day');
    const endTimeFormat = endTime.format('MM月DD日');
    return `活动时间：将在${endTimeFormat}失效`
  }

  const getAwardImg = (awardItem) => {
    if (awardItem.awardType === 0) {
      return Award5
    }
    if (awardItem.awardType === 3) {
      if (awardItem.name === '市值风云专属水杯') {
        return Award3
      }
      if (awardItem.name === '市值风云专属帆布袋') {
        return Award2
      }
    }
    if (awardItem.awardType === 11) {
      return Award1
    }
    if (awardItem.awardType === 1) {
      return Award4
    }
  }

  const getLeadText = (item) => {
    if (item.awardType === 0) {
      return '已领取'
    }
    if (item.awardType === 3) {
      if (addrInfo) {
        return '已领取'
      }
      return '去领取'
    }
    if (item.awardType === 11) {
      return '去查看'
    }
    if (item.awardType === 1) {
      return '已领取'
    }
  }

  const linkToDownload = () => {
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }

  const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

  useLayoutEffect(() => {
    if (bodyContainer.current && descContainer.current && awardLsit.length > 0) {
      const descContainerHeight = descContainer.current.clientHeight
      if (descContainerHeight > 188) {
        bodyContainer.current.style.paddingBottom = `${descContainerHeight - 188}px`
      }
      if (descContainerHeight > 220) {
        bodyContainer.current.style.paddingBottom = `${60}px`
      }
    }
  }, [awardLsit])

  useLayoutEffect(() => {
    if (token) {
      initPage()

      activityInfo({id: 120}).then(res => {
        if (res.state === 1) {
          setActiveVisible(true)
        } else {
          setActiveVisible(false)
        }
      })

      getAddrInfo({activityId: 120}).then(res => {
        if (res) {
          setAddrInfo(res)
        }
      })
    }
  }, [token]);

  useEffect(() => {
    h5Share.main({ 
      title: (userName || '') + '邀请您参加专享福利活动，新周边&VIP免费送',
      desc: '市值风云新用户专享福利活动，100%中奖，天天抽，天天乐',
      link: process.env.REACT_APP_DEMAND_URL + 'active_120',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo120.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo120.png'
        }
      }
    })


    bridge.callHandler('nativeEvent', {
      event: 'web_softinput_resize',
      params: {
        isImmersed: true
      }
    }, res => {})

    userBehaver({
      activeIdKey: "Activity_View",
      conId: `120`
    });
  }, [])

  const activityShare = () => {
    if (!isStorm) {
      linkToDownload()
      return
    }
    if (shareRef.current) {
      shareRef.current.show()
    }
  }

  const handleRaffle = () => {
    if (!isStorm) {
      linkToDownload()
      return
    }

    if (!token) {
      handleLogin()
      return
    }
    if (raffleCount === 0) {
      return
    }
    const isOverTime = isOverActivityTime();
    if (isOverTime) {
      return
    }
    if (!activeVisible) {
      return
    }
    if (isAnimating) {
      return
    }
    isAnimating = true
    lightRef.current.className = 'light-img'
    getDrawResult({ activityId: active_id }).then(res => {
      if (res.errors) {
        Toast.info(res.errors[0].message)
        lightRef.current.className = 'light-img light-flash'
        isAnimating = false
        return
      }

      setDrawAwardData(res.award);
      
      rotate(raffleRef.current, {
        angle:0,
        animateTo: 2880 - awardAngleMap.get(res.award.name) || 0,
        duration:8000,
        callback:function (){

          lightRef.current.className = 'light-img light-flash'
          isAnimating = false
          initPage();

          setShowModal(true)
        }
      });

      userBehaver({
        activeIdKey: "Activity_Start",
        conId: `120`
      });
    })
  }

  const handleConfirm = () => {
    if (drawAwardData.awardType === 0 || drawAwardData.awardType === 1) {
      Toast.info('已自动发放到账户');
    }
    if (drawAwardData.awardType === 11) {
      bridge.callHandler('nativeEvent', {
        event: 'showImage',
        params: {
          index: 0,
          imageList: ['https://file.wogoo.com/app/advertisement/20230829/eeb07a2ae32f4a3393a1c134739136a3.jpg'],
        }
      }, res => {})
    }
    if (drawAwardData.awardType === 3) {
      setVisible(true)
    }
    setShowModal(false);
  }

  const getAwardFont = (name) => {
    switch (name) {
      case "《价值投资全景图》电子版": return 22;
      case "市值风云专属帆布袋": return 22
      case "市值风云专属水杯": return 24
      default: return 30;
    } 
  }

  const handleSubmitAddr = (addr) => {
    setVisible(false);
    Toast.info('填写成功，奖品会在每月7日前统一邮寄');
    setAddrInfo(addr);
  }

  const handleLead = (item) => {
    if (item.awardType === 0) {
      jumpTo(process.env.REACT_APP_MOBOILE_URL + '/integral/account')
      return;
    }
    if (item.awardType === 1) {
      window.location.href = 'storm://app/user/memberCenter'
      return;
    }
    if (item.awardType === 0 || item.awardType === 1) {
      return;
    }
    if (item.awardType === 11) {
      bridge.callHandler('nativeEvent', {
        event: 'showImage',
        params: {
          index: 0,
          imageList: ['https://file.wogoo.com/app/advertisement/20230829/eeb07a2ae32f4a3393a1c134739136a3.jpg'],
        }
      }, res => {})
      return;
    }
    if (item.awardType === 3) {
      if (addrInfo) {
        deliveryRef.current.setParams(addrInfo);
      }
      setVisible(true);
    }
  }

  const getDrawBtnImg = () => {
    if (!isStorm || !token) {
      return WheelPointer;
    }
    if (!activeVisible) {
      return WheelPointerDark
    }
    if (isOverActivityTime()) {
      return WheelPointerDark
    }
    if (canDrawTomorrow()) {
      if (raffleCount > 0) {
        return WheelPointer
      }
      return DrawTomorrow;
    }
    if (raffleCount === 0) {
      return WheelPointerDark
    }
    return WheelPointer
  }

  const getConfirmBtn = () => {
    let className = 'lead-btn';
    let btn = '';
    if (drawAwardData.awardType === 0 || drawAwardData.awardType === 1 || drawAwardData.awardType === 11) {
      btn = LeadBtn;
      className = 'lead-btn';
    } else {
      btn = DeliveryBtn;
      className = 'delivery-btn';
    }
    return <img onClick={handleConfirm} className={className} src={btn} alt=""/>
  }

  return <Container style={isStorm ? {} : {paddingTop: 0}} ref={bodyContainer}>
    <div className="page-body">
      {isStorm && 
        <Header
          title="新用户专享福利"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
          bg_color={styles.bg_color2}
        />
      }
      <div className="bg-container">
        <img className="bg-img" src={ActiveBG} alt=""/>
        <div className="activityTime">{getActivityTime()}</div>
      </div>

      {awardLsit.length > 0 && <div className="bottom-container">
        <div className="bottom-box">
          <div className="award-title">我的奖品</div>
          <div className="award-content">
            {awardLsit.map((item, index)=> {
              const isInActive = item.awardType === 0 || item.awardType === 1
              return <div className="award-item" key={index} onClick={() => handleLead(item)}>
                <div className="award-img" style={{backgroundImage: `url(${getAwardImg(item)})`}}>
                  <div className="award-name">{item.name}</div>
                </div>
                <div className={isInActive ? 'to-lead lead-inactive' : 'to-lead'}>{getLeadText(item)}</div>
              </div>
            })}
          </div>
          
        </div>
      </div>}

      <div className="wheel-container">
        <div className="wheel-img-bg">
          <div ref={raffleRef} className="raffle-container">
            <img className="wheel-bg" alt="" src={WheelBG} />
            <div className="light-container">
              <img className="light-img light-flash" ref={lightRef} alt="" src={WheelLight} />
            </div>
          </div>
          <div className="pointer-container">
            <div className="pointer-box">
              <img className="pointer-img" alt="" src={getDrawBtnImg()} />
              <div onClick={handleRaffle} className="raffle-area"/>
            </div>
          </div>
          <div className="stand-container">
            <div className="stand-box">
              <img className="stand-img" alt="" src={StandBG} />
              <div className="stand-text">剩余抽奖次数：{raffleCount}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="describe-container" ref={descContainer}>
        <div className="desc-title-wrap">
          <img className="desc-title" src={DescTitle} alt="" />
        </div>
        <div className="desc-text-wrap">
          <div className="content-title">一、如何参与抽奖？</div>
          <div className="fix-bottom">新用户专享福利仅限APP新注册用户参与</div>
          <div className="content-title">二、抽奖次数如何获得？</div>
          <div className="fix-bottom">新用户注册后7天内（含当日）每天进入抽奖页面，可获得1次抽奖机会</div>
          <div className="content-title">三、抽到的奖品怎么兑奖呢？</div>
          <div className="fix-bottom">1.会员/积分奖品：自动发送到获奖用户的风云账户中</div>
          <div className="fix-bottom">会员：APP【我的】-【VIP会员中心】-【已购服务】</div>
          <div className="fix-bottom">积分：APP【我的】-【积分中心】-【明细】</div>
          <div className="fix-bottom">2.全景图奖品：点击“去查看”按钮即可到达奖品页面</div>
          <div className="fix-bottom">3.实物奖品：点击“去领取”按钮即可去填写邮寄地址（奖品会在每月7日前邮寄）</div>
          <div className="content-title">四、可以将抽奖次数攒起来一口气抽吗？</div>
          <div className="fix-bottom">可以的，只要在活动期间获得的抽奖次数，在活动期间都可使用。</div>
          <div className="fix-bottom">但活动结束后抽奖次数将清零，所以建议获得后尽快使用。</div>
          <div className="content-title">五、怎么才能提高我的中奖机会呢？</div>
          <div>中奖概率是系统随机产生的哦～</div>
          <div>但是，听说在活动期间每天有发帖、玩交易训练营的人都会更幸运点哦～</div>

          <div className="explain-botom">本活动最终解释权归市值风云官方所有</div>
        </div>
      </div>
      <ModalView
        visible={showModal}
        over
        content={
          <RewardCard>
            <div className="reward-card-wrap">
              <img className="reward-bg" src={RewardBG} alt=""/>
              <img onClick={() => setShowModal(false)} className="close-btn" src={CloseBtn} alt=""/>
              <div className="btn-wrap">
                {getConfirmBtn()}
              </div>
              <div className="draw-result">
                <div className="reward-alert1">恭喜您，抽中</div>
                <div className="reward-alert2" style={{fontSize: getAwardFont(drawAwardData.name)}}>{drawAwardData.name}</div>
                <div className="award-label">奖励已发放到当前账户</div>
              </div>
            </div>
          </RewardCard>
        }
      />
      <ModalView
        visible={showEmptyModal}
        onClose={() => setShowEmptyModal(false)}
        onOverlayClick={() => setShowEmptyModal(false)}
        content={
          <ExplainCard>
            <div className="empty-wrap">
              <img src={EmptyCard} alt='' className="empty-card" />
              <img onClick={() => setShowEmptyModal(false)} className="close-btn empty-close-btn" src={CloseBtn} alt=""/>
            </div>
          </ExplainCard>
        }
      />
    </div>
    <ShareModal ref={shareRef} userName={userInfo.nickname} />

    <Delivery visible={visible} ref={deliveryRef} onClose={() => setVisible(false)} onSubmit={handleSubmitAddr} activityId={120} />
  </Container>;
}

const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(CarnivalGame))

const RewardCard = styled.div`
  width: 100%;
  height: 259px;
  padding: 0 34px;
  box-sizing: border-box;
  .reward-card-wrap {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .reward-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .close-btn {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 21.5px;
    right: 27.5px;
    z-index: 5;
  }
  .btn-wrap {
    position: absolute;
    bottom: 9.5px;
    width: 100%;
    height: 52.5px;
    left: 0;
    display: flex;
    justify-content: center;
  }
  .lead-btn {
    width: 154px;
    height: 47.5px;
  }
  .delivery-btn {
    width: 154px;
    height: 47.5px;
  }
  .draw-result {
    position: relative;
    z-index: 2;
    text-align: center;
    padding-top: 35px;
    .reward-alert1 {
      font-size: 19px;
      font-weight: 500;
      color: #676767;
      line-height: 19px;
    }
    .reward-alert2 {
      font-size: 37.5px;
      font-weight: 800;
      color: #C15200;
      line-height: 37.5px;
      margin-top: 14px;
      margin-bottom: 18px;
    }
    .award-label {
      text-align: center;
      color: #676767;
    }
  }

`;

const ExplainCard = styled.div`
  .empty-wrap {
    position: relative;
    width: 100%;
    .empty-card {
      width: 277.5px;
      height: 214px;
    }
    .empty-close-btn {
      right: 6px;
      top: 6px;
      width: 20px;
      height: 20px;
      position: absolute;
      z-index: 5;
    }
  }
`;

const Container = styled.div`
  padding-top: 44px;
  max-width: 100%;
  overflow: hidden;
  .page-body {
    position: relative;
  }
  .bg-container {
    width: 100%;
    position: relative;
    z-index: 0;
    .bg-img {
      width: 100%;
    }
    .activityTime {
      position: absolute;
      left: 0;
      top: 59.4vw;
      width: 100%;
      text-align: center;

      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
    }
  }
  .explain-btn {
    position: fixed;
    top: 273px;
    right: 0;
    width: 47px;
    height: 50.5px;
    z-index: 10;
  }
  .bottom-container {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    font-size: 0;
    z-index: 10;
    .bottom-box {
      width: 100%;
      height: 185px;
      position: relative;
      background-color: #FF9F40;
      border-radius: 10px 10px 0px 0px;
      padding: 12px 15px 0;
      box-sizing: border-box;
    }
    .award-title {
      width: 105px;
      height: 30px;
      border-radius: 15px;
      border: 1.5px solid #FFFFFF;
      box-sizing: border-box;
      line-height: 30px;
      text-align: center;
      font-weight: 500;
      font-size: 16px;
      color: #fff;
    }
    .award-content {
      margin-top: 8px;
      display: flex;
      overflow-y: scroll;
      
      .to-lead {
        margin-top: 11.5px;
        width: 72.5px;
        height: 21px;
        background: #FFDE00;
        border-radius: 10.5px;
        font-size: 12px;
        font-weight: 500;
        text-align: center;
        line-height: 21px;
        color: #000;
      }
      .lead-inactive {
        background: #DADADA;
      }
      .award-item {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
      .award-img {
        width: 80px;
        height: 84px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .award-name {
        height: 78px;
        font-size: 9.5px;
        box-sizing: border-box;
        padding: 55px 10px 0;
        text-align: center;
        color: #A92D2D;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .award-content::-webkit-scrollbar {
      display: none;
    }
    .award-content::-webkit-scrollbar {
      display: none;
    }
  }

  .raffle-container {
    position: relative;
    z-index: 1;
  }

  .wheel-container {
    width: 100%;
    position: absolute;
    top: 73vw;
    left: 0;
    display: flex;
    justify-content: center;
    .wheel-img-bg {
      margin: 0 10px;
      position: relative;
      font-size: 0;
      max-width: 355px;
      .wheel-bg {
        width: 100%;
        position: relative;
        z-index: 1;
      }
      .pointer-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
        justify-content: center;
        display: flex;
        align-items: center;
        .pointer-box {
          font-size: 0;
          width: 111px;
          height: 111px;
          position: relative;
          .pointer-img {
            width: 111px;
            position: absolute;
            bottom: 0;
            left: 0;
          }
          .raffle-area {
            width: 111px;
            height: 111px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 3;
          }
        }
      }
    }
    .light-container {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      .light-img {
        width: 100%;
        height: 100%;
      }
    }
    .stand-container {
      position: absolute;
      height: 46px;
      width: 100%;
      bottom: -36.5px;
      left: 0;
      .stand-box {
        position: relative;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0;
        .stand-img {
          width: 259.5px;
          height: 46px;
        }
        .stand-text {
          font-size: 15px;
          line-height: 15px;
          text-align: center;
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 10.5px;
          color: #FFFEEE;
        }
      }
    }
  }
  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }

  .describe-container {
    position: absolute;
    left: 0;
    top: 186vw;
    width: 100%;
    .desc-title-wrap {
      display: flex;
      justify-content: center;
      .desc-title {
        width: 241.5px;
        height: 22.55px;
      }
    }
    .desc-text-wrap {
      width: 100%;
      padding-left: 23.5px;
      padding-right: 17.5px;
      margin-top: 18.5px;
      font-size: 15px;
      color: #FDFDFD;
      font-weight: 400;
      line-height: 19px;
      box-sizing: border-box;
      .content-title {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 10px;
      }
      .fix-bottom {
        margin-bottom: 10px;
      }
    }
  }
  .explain-botom {
    text-align: center;
    margin-top: 50px;
    font-size:11px;
  }

  @keyframes light-flash {
    0% { opacity: 1; }
    25% { opacity: 0; }
    50% { opacity: 1; }
    75% { opacity: 0; }
    100% { opacity: 1; }
  }
  .light-flash {
    animation-name: light-flash;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_120/index.js